import { preProcessHumanizer } from './preProcessModule'

export default preProcessHumanizer
